export const sowCardId = 1;
export const fertilizingCardId = 2;
export const modificationCardId = 3;
export const pesticideCardId = 4;
export const harvestCardId = 5;
export const memoCardId = 6;